<template>
  <div>
    <v-row>
      <h1 class="ml-4">Organisations</h1>
    </v-row>
    <v-row class="mt-2 reduce-zoom">
      <v-col>
        <total-organisations-statistics-card />
      </v-col>
      <v-col> </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-text-field
          v-model="search"
          placeholder="Type an organisations name to search..."
          outlined
          clearable
          counter
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="organisations.records"
          :loading="isLoading"
          :search="search"
          transition="scale-transition"
          class="new-detault-table organisations-view"
        >
          <template v-slot:top>
            <v-row class="card-slider mb-4" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4">
                <download-excel
                  class="text-right"
                  :data="organisations.records"
                  :fields="fields"
                  worksheet="Organisations"
                  name="CRMOrganisationList.xls"
                >
                  <v-btn class="text-right" color="#0a2752" large dark>
                    <h1>Download</h1>
                  </v-btn>
                </download-excel>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-btn
                  dark
                  color="primary"
                  large
                  @click="$router.push('/admin/organisation/0/edit')"
                  ><h1>Create new Organisation</h1></v-btn
                >
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.createdAt="{ item }">
            <h3 color="primary">{{ item.createdAt | getFormattedDate }}</h3>
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <h3 color="primary">{{ item.updatedAt | getFormattedDate }}</h3>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              x-small
              dark
              class="mr-2"
              @click="editItem(item)"
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              fab
              x-small
              dark
              class="ml-2"
              @click="deleteItem(item)"
              color="blue darken-2"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";
// import TotalOrganisationsStatisticsCard from "../../../components/Base/StatsCards/TotalOrganisationsStatisticCard.vue";
export default {
  components: { defaultProfile },
  data() {
    return {
      fields: {
        "Organisation Name": "name",
        "Organisation Id": "id",
        "Created At": "createdAt",
      },
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Created Date", value: "createdAt" },
        { text: "Updated Date", value: "updatedAt" },
        { text: "Actions", align: "right", sortable: false, value: "actions" },
      ],
      search: "",
      organisations: [],
      totalRecords: 0,
      isLoading: false,
    };
  },

  apollo: {
    organisations: {
      query: gql`
        query Organisations($limit: Int!, $skip: Int!, $query: JSON!) {
          organisations(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },

  methods: {
    editItem(item) {
      this.$router.push(`/admin/organisation/${item.id}/edit`);
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteOrganisation(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal(
                "Success!",
                "Organisation was successfully deleted",
                "success"
              );
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {}
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
